<template>
  <client-only>
    <el-dialog title="" :visible.sync="showLogin" width="1060px" :before-close="handleClose" :lock-scroll="false" :show-close="false">
      <el-dialog width="30%" title=" " :visible.sync="innerVisible" append-to-body>
        <captcha @overVerify="overVerify" :autoLoad="innerVisible" :phone="phone" :type="type"></captcha>
      </el-dialog>
      <div class="login-page">
        <div class="page-img">
          <img class="img-self" src="~@/assets/images/login-top-img.png" alt="">
          <p class="img-text" v-if="type === 1" >欢迎登录</p>
          <p class="img-text" v-if="type === 2">注册账号</p>
          <p class="img-text" v-if="type === 3">找回密码</p>
        </div>
        <div class="page-form">
          <div class="form-nav">
            <div class="nav-item">
              <p class="nav-text" :class="{'active': type === 1}" @click="type = 1">登录</p>
            </div>
            <div class="nav-item">
              <p class="nav-text" :class="{'active': type === 2}" @click="type = 2">注册</p>
            </div>
            <div class="nav-item">
              <p class="nav-text" :class="{'active': type === 3}" @click="type = 3">找回密码</p>
            </div>
          </div>
          
          <div class="form-login" v-if="type === 1">
            <el-form ref="loginForm" :model="form" :rules="rules"  @submit.native.prevent="handleLogin">
              <el-form-item prop="username" label="姓名">
                <el-input v-model="form.username" placeholder="请输入用户名" prefix-icon="el-icon-user" size="large" ></el-input>
              </el-form-item>
              <el-form-item prop="password" label="密码">
                <el-input v-model="form.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" size="large" show-password></el-input>
              </el-form-item>
              <el-form-item>
                <div class="form-box">
                  <el-checkbox v-model="form.remember">记住密码</el-checkbox>
                  <p class="forget-pwd" @click="type = 3">忘记密码</p>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="form-register" v-if="type === 2">
            <el-form ref="registerForm" :model="register" label-position="top" :rules="registerRules" inline>
              <el-form-item prop="name" label="用户名">
                <el-input class="form-ipt" v-model="register.name" placeholder="请输入用户名" prefix-icon="el-icon-user" size="large" ></el-input>
              </el-form-item>
              <el-form-item prop="phone" label="手机号">
                <el-input class="register-phone" v-model="register.phone" placeholder="请输入手机号" prefix-icon="el-icon-phone-outline" size="large">
                  <el-button class="register-btn" slot="append" @click="getGenerate" :disabled="registerDisabled">{{ registerText }}</el-button>
                </el-input>
              </el-form-item>
              <el-form-item prop="code" label="验证码">
                <el-input class="form-ipt" v-model="register.code" placeholder="请输入验证码" prefix-icon="el-icon-message" size="large"></el-input>
              </el-form-item>
              <el-form-item prop="password" label="密码">
                <el-input class="form-ipt" v-model="register.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" size="large" show-password></el-input>
              </el-form-item>
              <el-form-item prop="confirm_password" label="再次确认密码">
                <el-input class="form-ipt" v-model="register.confirm_password" type="password" placeholder="再次确认密码" prefix-icon="el-icon-lock" size="large" show-password></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="form-password" v-if="type === 3">
            <el-form ref="passwordForm" :model="password" label-position="top" :rules="passwordRules" inline>
              <el-form-item prop="phone" label="手机号">
                <el-input class="register-phone" v-model="password.phone" placeholder="请输入手机号" prefix-icon="el-icon-phone-outline" size="large">
                  <el-button class="register-btn" slot="append" @click="getGenerate" :disabled="passwordDisabled">{{ passwordText }}</el-button>
                </el-input>
              </el-form-item>
              <el-form-item prop="code" label="验证码">
                <el-input class="form-ipt" v-model="password.code" placeholder="请输入验证码" prefix-icon="el-icon-message" size="large"></el-input>
              </el-form-item>
              <el-form-item prop="password" label="密码">
                <el-input class="form-ipt" v-model="password.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" size="large" show-password></el-input>
              </el-form-item>
              <el-form-item prop="password_confirmation" label="再次确认密码">
                <el-input class="form-ipt" v-model="password.password_confirmation" type="password" placeholder="再次确认密码" prefix-icon="el-icon-lock" size="large" show-password></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="form-btn">
            <p class="btn-text login" v-if="type === 1" @click="type = 2">注册账号</p>
            <p class="btn-text" :class="{'password': type === 3, 'sign': type === 2}" v-if="type === 2 || type === 3" @click="type = 1">去登录</p>
            <el-button type="primary" v-if="type === 1"  @click="handleLogin"  size="large" :loading="loading" class="btn-self">登录</el-button>
            <el-button type="primary" v-if="type === 2"  @click="sign"  size="large" :loading="loading" class="btn-self">提交</el-button>
            <el-button type="primary" v-if="type === 3"  @click="changePassword"  size="large" :loading="loading" class="btn-self">提交</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </client-only>
</template>

<script>
import captcha from '@/components/captcha'
export default {
  middleware({ store, redirect }) {
    // 如果已经登录，跳转到首页
    if (store.state.token) {
      return redirect('/')
    }
  },
  
  data() {
    return {
      type:  1,
      form: {
        username: '',
        password: '',
        remember: true
      },
      loading: false,
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { message: '请输入正确的用户名格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 0, message: '请输入密码', trigger: 'blur' }
        ]
      },
      registerRules:{
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { message: '请输入正确的用户名格式', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { message: '请输入正确的验证码格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 0, message: '请输入密码', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 0, message: '请输入密码', trigger: 'blur' }
        ]
      },
      passwordRules:{
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { message: '请输入正确的手机号格式', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { message: '请输入正确的验证码格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 0, message: '请输入密码', trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 0, message: '请输入密码', trigger: 'blur' }
        ]
      },
      register: {
        name: '',
        phone: '',
        password: '',
        code: '',
        confirm_password: ''
      },
      password: {
        phone: '',
        code: '',
        password: '',
        password_confirmation: ''
      },
      innerVisible: false,
      registerText: '获取验证码',
      passwordText: '获取验证码',
      timer: null,
      registerDisabled: false,
      passwordDisabled: false,
      phone: ''
    }
  },

  computed: {
    showLogin() {
      return this.$store.state.showLogin
    }
  },
  components: {
    captcha
  },
  methods: {
    // 登录
    async handleLogin() {
      try {
        this.loading = true
        if (!this.form.username) {
          this.$message.warning('请输入正确的用户名')
          this.loading = false
          return false
        }
        if (!this.form.password) {
          this.$message.warning('请输入密码')
          this.loading = false
          return false
        }
        // 验证表单
        const valid = await this.$refs.loginForm.validate()
        if (!valid) return
        // 调用登录操作
        const result = await this.$store.dispatch('login', {
          username: this.form.username,
          password: this.form.password,
          remember: this.form.remember
        })
        if (result.success) {
          this.$message.success('登录成功！')
          this.$store.commit('setShowLogin', false)
        } else {
          this.$message.error(result.message || '登录失败')
        }
      } catch (error) {
        this.$message.error('登录过程中发生错误')
      } finally {
        this.loading = false
      }
    },
    // 获取验证码
    getGenerate () {
      if (this.type === 2 && this.register.phone === '') {
        this.$message.warning('请输入手机号')
        return false
      }
      if (this.type === 3 && this.password.phone === '') {
        this.$message.warning('请输入手机号')
        return false
      }
      if (this.type === 2) {
        this.phone = this.register.phone
      } else if (this.type === 3) {
        this.phone = this.password.phone
      }
      this.innerVisible = true
    },
    // 注册
    async sign() {
      // 验证表单
      if (this.register.name === '') {
        this.$message.warning('请输入用户名')
        return false
      }
      if (this.register.phone === '') {
        this.$message.warning('请输入手机号')
        return false
      }
      if (this.register.code === '') {
        this.$message.warning('请输入验证码')
        return false
      }
      if (this.register.password === '') {
        this.$message.warning('请输入密码')
        return false
      }
      if (this.register.confirm_password === '') {
        this.$message.warning('请输入确认密码')
        return false
      }
      if (this.register.password !== this.register.confirm_password) {
        this.$message.warning('两次密码不相同，请重新输入')
        return false
      }
      try {
        this.loading = true
        let res = await this.$api.post('student_new/register', {
          name: this.register.name,
          phone: this.register.phone,
          password: this.register.password,
          code: this.register.code
        })
        if (res.code === 200) {
          this.loading = false
          this.$message.success('注册成功！')
        } else {
          this.$message.error(res.message || '注册失败')
          this.loading = false
        }
      } catch (error) { 
      }
    },
    // 忘记密码
    async changePassword () { 
      if (this.password.phone === '') {
        this.$message.warning('请输入手机号')
        return false
      }
      if (this.password.code === '') {
        this.$message.warning('请输入验证码')
        return false
      }
      if (this.password.password === '') {
        this.$message.warning('请输入密码')
        return false
      }
      if (this.password.password_confirmation === '') {
        this.$message.warning('请输入确认密码')
        return false
      }
      if (this.password.password !== this.password.password_confirmation) {
        this.$message.warning('两次密码不相同，请重新输入')
      }
      try {
        this.loading = true
        let res = await this.$api.put('student_new/sms_change_password', {
          phone: this.password.phone,
          code: this.password.code,
          password: this.password.password,
          password_confirmation: this.password.password_confirmation
        })
        if (res.code === 200) {
          this.loading = false
          this.$message.success('修改密码成功！')
        } else {
          this.loading = false
          this.$message.error(res.message || '修改密码失败')
        }
      } catch (response) {
        this.$message.error('修改密码失败')
        this.loading = false
      }
    },
    // 关闭登录框
    handleClose () {
      this.clearTimer()
      this.$store.commit('setShowLogin', false)
    },
    // 滑动验证成功
    overVerify() {
      this.innerVisible = false
      let time = 60
      this.timer = setInterval(() => {
        time--
        if (this.type === 2) {
          this.registerText = time + "s"
          this.registerDisabled = true
        } else if (this.type === 3) {
          this.passwordText = time + "s"
          this.passwordDisabled = true
        }
        if ( time === 0 ) {
          this.clearTimer()
        }
      }, 1000)
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      if (this.type === 2) {
        this.registerText = '获取验证码'
        this.registerDisabled = false
      } else if (this.type === 3) {
        this.passwordText = '获取验证码'
        this.passwordDisabled = false
      }
    }
  },
  beforeDestroy() {
    this.clearTimer()
  }
}
</script>

<style scoped>
:deep(.el-dialog__header){padding:0;}
:deep(.el-dialog__body){padding:0;}
:deep(.el-form-item__content){margin:0 auto;}
.page-form :deep(.el-checkbox__input.is-checked .el-checkbox__inner){background-color: #198052;border-color: #198052;}
.page-form :deep(.el-checkbox__input.is-checked + .el-checkbox__label){color: #198052;}
.login-page{display:flex;}
.form-nav{display:grid;grid-template-columns:repeat(3, 1fr);padding:0 0 20px;}
.form-nav .nav-item{text-align:center;border-bottom:1px solid #E5E5E5;}
.form-nav .nav-item .nav-text{margin-bottom:10px;position:relative;color:#000;font-size:12px;cursor:pointer;}
.form-nav .nav-item .nav-text.active{color:#198052;}
.form-nav .nav-item .nav-text::after{content:"";position:absolute;left:50%;bottom:-17px;display:block;width:14px;height:14px;border-radius:14px;background-color:#CCCCCC;transform:translate(-50%, 0);}
.form-nav .nav-item .nav-text.active::after{background-color:#198052;}
.login-page .page-img{position:relative;}
.login-page .page-img .img-self{display:block;width:400px;}
.login-page .page-img .img-text{position:absolute;font-size:24px;font-weight:bold;color:#fff;left:40px;bottom:150px;}
.page-form{background-color:#fff;padding:20px 25px;box-sizing:border-box;flex:1;}
.page-form .form-login{width:280px;margin:0 auto;}
.form-box{display:flex;justify-content: space-between;}
.forget-pwd{cursor:pointer;}
.form-btn .btn-text{text-align:center;color:#198052;margin-bottom:10px;cursor:pointer;}
.form-btn .btn-text.password{margin-top:112px;}
.form-btn .btn-text.login{margin-top:92px;}
.form-btn .btn-self{display:block;width:280px;background-color:#198052;border-color:#198052;border-radius:40px;margin:0 auto;}
:deep(.el-input-group__append button.el-button){display:block;color:#fff;background-color:#198052;width:100px;border:1px solid #198052;text-align:center;border-radius:0 4px 4px 0;}
.form-ipt{width:292px;}
.register-phone{width:292px;}
</style>